import styled from "styled-components";
import * as global from './../helpers/Helper'
import ImgLogo from './../../assets/img/social-logo.png'

export const HeaderContainer = styled.header`
  position: fixed;
  height: 60px;
  width: 100%;
  background-color: ${global.ColorMain};
  border-bottom: 1px solid ${global.ColorSec};  
  @media (min-width: 768px) {
    height: 140px;
  }
  @media (min-width: 1200px) {
    height: 80px;
  }
`
export const HeaderMax = styled.div`
  width: 95%;
  height: 60px;
  margin: 0 auto;
  max-width: 1400px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media (min-width: 768px) {
    flex-direction: column;
    height: 140px;
    justify-content: center;
    gap: 24px;
  }
  @media (min-width: 1200px) {
    flex-direction: row;
    gap: 0;
    justify-content: space-between;
    height: 80px;
  }
`
export const Logo = styled.h1`
  color: ${global.ColorRed};
  font-size: 36px;
  line-height: 36px;
  @media (min-width: 768px) {
    font-size: 42px;
    line-height: 42px;
  }
  @media (min-width: 1200px) {
    font-size: 48px;
    line-height: 48px;
  }
`
export const Toggle = styled.label`
  cursor: pointer;
  display: inline-grid;
  row-gap: 7px;
  position: relative;
  @media (min-width: 768px) {
    display: none;
  }
`
export const Bar = styled.span`
  background-color: ${global.ColorSec};
  height: 6px;
  width: 42px;
  border-radius: 10px;
  transition: all .5s;
  &:nth-child(1) {   
    transform:
    ${({ isOpen }) => isOpen ? 
      'translate(0px, 13px) rotate(45deg)' 
    : 
      'translate(0px, 0px) rotate(0)'}; 
  }
  &:nth-child(2) {   
    transform:
    ${({ isOpen }) => isOpen ? 
      'translateX(15px)' 
    : 
      'ttranslateX(0)'}; 
    opacity:
    ${({ isOpen }) => isOpen ? 
      '0' 
    : 
      '1'}; 
  }
  &:nth-child(3) {   
    transform:
    ${({ isOpen }) => isOpen ? 
      'translate(0px, -13px) rotate(-45deg)' 
    : 
      'translate(0px, 0px) rotate(0)'}; 
  }
`
export const Nav = styled.nav`
  -webkit-box-align: center;
  position: fixed;
  top: 59px;
  height: calc( 100% - 59px );
  width: 100%;
  background-color: ${global.ColorMain};
  right:
  ${({ isOpen }) => isOpen ? '0px' : '-100%'}; 
  transition: .5s all;
  padding: 60px 0px;
  display: flex;
  flex-direction: column;
  @media (min-width: 768px) {
    position: static;
    padding: 0;
    display: inline;
    height: auto;
  }
`
export const NavList = styled.ul`
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 24px;
  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: center;
    gap: 0px;
  }
  @media (min-width: 1200px) {
    justify-content: flex-end;
  }
`
export const NavItem = styled.li`
  list-style: none;
`
export const Link = styled.a`
  color: ${global.ColorSec};
  font-family: ${global.FontSigmar};
  font-size: 32px;
  &.active {
    color: ${global.ColorRed};
  }
  &:hover {
    color: ${global.ColorRed};
    transition: .5s all;
  }
  @media (min-width: 768px) {
    font-size: 30px;
    padding: 0px 15px;
    border-radius: 30px;
    &.active {
      background-color: ${global.ColorRed};
      color: ${global.ColorWhite};
    }
  }
`
export const NavSocial =styled.div`
  margin-top: auto;
  display: flex;
  flex-direction: column;
  gap: 18px;
  align-items: center;
  @media (min-width: 768px) {
    display: none; 
  }
`
export const NavLogo = styled.img.attrs({ src: `${ImgLogo}`})`
  width: 120px;
`